import { ActivatedRoute, Router } from '@angular/router';
import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';

import { FormGroup } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { FormlyJsonschema } from '@ngx-formly/core/json-schema';
import { JSONSchema7 } from 'json-schema';
import { Location } from '@angular/common';
import { MainService } from '../main.service';
import { Subscription } from 'rxjs';
import Swal from 'sweetalert2';

export interface ComponentConfig {
  mode: 'create' | 'update' | 'view'; // Indicates the mode of the component
  header: string
  pf_path: string; // Path for API requests
  pf_name: string; // Name for API requests
  app_cd: string; // Application code
  formData?: any; // Data to be displayed in view or edit mode
}

@Component({
  selector: 'app-rrv',
  templateUrl: './rrv.component.html',
  styleUrls: ['./rrv.component.css']
})
export class RrvComponent implements OnInit {
  rrvconfig: ComponentConfig
  constructor(private dataService: MainService,
    private route: ActivatedRoute,
    private router: Router, private formlyJsonschema: FormlyJsonschema,
    private location: Location, private cdr: ChangeDetectorRef) {
  }
  model = {}
  async ngOnInit() {
    let obj: any = this.route.snapshot.queryParamMap.get('id');
    console.log(obj);
    let a = window.atob(obj)
    let b = JSON.parse(a);
    this.rrvconfig = b
    console.log(b);
    // this.table_nm =this.rrvconfig.header
    // this.pf_path = this.rrvconfig.pf_path 
    // this.pf_name = this.rrvconfig.pf_name
    await this.getFields()
    console.log(this.dataService.dependent_on, this.form);
    if (this.dataService?.dependent_on) {

      await this.subscribetoondependentchange(this.dataService?.dependent_on)
      if (this.model[this.dataService.dependent_on]) {
        await this.getjsonschemaaspernewval(this.model[this.dataService.dependent_on]);

      }
    }







    // this.form.valueChanges.subscribe(value => {
    //   if(value?.['ip_tcd'])
    //   console.log('Form value changed:', value);
    // });
  }

  columns = []
  private subscriptions: Subscription = new Subscription();
  async subscribetoondependentchange(dependent_on) {
    let formSubscription: Subscription;
    let controlSubscription: Subscription;
    const manageFormSubscription = () => {

      if (formSubscription) {
        formSubscription.unsubscribe();
      }
      formSubscription = this.form.valueChanges.subscribe((value) => {
        if (controlSubscription) {
          controlSubscription.unsubscribe();
        }
        controlSubscription = this.form.controls[dependent_on]?.valueChanges.subscribe(async (newValue) => {
          console.log('Field value changed:', newValue);
          console.log(this.model[this.dataService.dependentTerm]);
          await this.getjsonschemaaspernewval(newValue);
          this.model[this.dataService.dependentTerm] = {};
        });

        this.subscriptions.add(controlSubscription);
      });

      this.subscriptions.add(formSubscription);
    };


    manageFormSubscription();
  }

  async getjsonschemaaspernewval(newValue: any) {
    let term = this.terms.filter(item => item.di_tech_nm == this.dataService.dependentTerm)[0]
    let schema = await this.dataService.getSchemaByType(term['datatype'], newValue);
    if (schema) {
      await this.dataService.addTitlesToSchema(schema);

      this.schema['properties'][this.dataService.dependentTerm] = schema
      this.fields = [this.formlyJsonschema.toFieldConfig(this.schema, {
        map: (field: FormlyFieldConfig, schema: JSONSchema7) => {
          if (this.rrvconfig.mode === 'view') {
            field.templateOptions.disabled = true;
          }
          if (schema.format === 'date-time') {
            field.templateOptions.type = 'datetime-local';
          } else if (schema.format === 'date') {
            field.templateOptions.type = 'date';
          } else if (schema.format === 'time') {
            field.templateOptions.type = 'time';
          } else if (schema.format === 'email') {
            field.templateOptions.type = 'email';
          }
          // if (schema.title && schema.title.startsWith('Dictionary Item')) {
          //   field.templateOptions.label = schema.title.replace('Dictionary Item', this.rrvconfig?.header['value']);
          // } 
          // else {
            field.templateOptions.label = schema.title;
          // }
          if (typeof field.key === 'string' && field.key.includes('json')) {
            if (!this.model[field.key]) {
              this.model[field.key] = JSON.stringify({});
            }
          }

          return field;
        }
      })];

    }




  }

  async getFields(): Promise<void> {
    try {
      let physicalFileRequest = {
        di_tech_nm: this.rrvconfig.pf_name,
        di_tcd: 'PF'
      };

      let physicalFileResponse = await this.dataService.getdtls(physicalFileRequest);
      if (physicalFileResponse['error'] === false && physicalFileResponse['data'].length > 0) {
        console.log(physicalFileResponse['data'][0]);
        let physicalFileDetails = physicalFileResponse['data'][0];

        let logicalFileRequest = {
          di_tech_nm: physicalFileDetails?.['di_tcd_json']?.['default_lf']?.['di_tech_nm'],
          di_tcd: 'LF'
        };

        let logicalFileResponse = await this.dataService.getdtls(logicalFileRequest);
        if (logicalFileResponse['error'] === false && logicalFileResponse['data'].length > 0) {
          console.log(logicalFileResponse['data'][0]);

          let logicalRecordRequest = {
            di_tech_nm: logicalFileResponse['data'][0]?.['di_tcd_json']?.['default_lr']?.['di_tech_nm'],
            di_tcd: 'LR'
          };

          let logicalRecordResponse = await this.dataService.getdtls(logicalRecordRequest);
          if (logicalRecordResponse['error'] === false && logicalRecordResponse['data'].length > 0) {
            console.log(logicalRecordResponse['data'][0]['objDi']);
            let logicalRecordFields = logicalRecordResponse['data'][0]['objDi'];

            let columnNames = logicalRecordFields.map((field: any) => field['di_tech_nm']);
            await this.getFieldDtls(columnNames);
          } else {
            console.error('Error fetching logical record details:', logicalRecordResponse['error'] || 'No data found');
          }
        } else {
          console.error('Error fetching logical file details:', logicalFileResponse['error'] || 'No data found');
        }
      } else {
        console.error('Error fetching physical file details:', physicalFileResponse['error'] || 'No data found');
      }
    } catch (error) {
      console.error('An error occurred in getFields:', error);
    }
  }


  // private async getFields(): Promise<void> {
  //   try {
  //     const response = await this.dataService.getListData({ pf_path: this.rrvconfig.pf_path, pf_name: this.rrvconfig.pf_name, app_cd: this.rrvconfig.app_cd, limit: 1 });
  //     console.log('Data fetched successfully:', response);

  //     const dataArray = response.data;

  //     if (Array.isArray(dataArray) && dataArray.length > 0) {
  //       this.columns = Object.keys(dataArray[0]);
  //       console.log('Columns:', this.columns);

  //       await this.getFieldDtls(this.columns);
  //     } else {
  //       console.warn('Response is not in the expected format.');
  //     }
  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //   }
  // }
  schema: any = {}
  terms: any = []
  private async getFieldDtls(columns: string[]): Promise<void> {
    this.schema = {}
    console.log(columns);
    // const filteredArrayid = columns.filter(value => !value.toLowerCase().includes('_id'));
    await this.findpk()
    const filteredArrayid = columns.filter(field => !this.pk.includes(field));
    //  console.log(filteredArray);
    const excludedColumns = ['captured_at', 'updated_at', 'deleted_at', 'bus_actv_cd', 'tech_comp_cd', 'rid', 'uid', 'status_cd', 'valid_from', 'valid_upto'];

    let filteredArray = filteredArrayid.filter(field => !excludedColumns.includes(field));

    try {
      const response = await this.dataService.getMultipleBusinessName({ act_id: 2, di_tech_nm: filteredArray, app_cd: this.rrvconfig.app_cd, di_tcd: 'TR', });
      console.log('Data fetched successfully:', response);

      const dataArray = response.data;
      //  this.diArrObj = dataArray;
      console.log(response.data);
      const sortedDataArray = dataArray.sort((a, b) => a.di_id - b.di_id);
      this.terms = sortedDataArray
      console.log(sortedDataArray);


      if (Array.isArray(dataArray) && dataArray.length > 0) {
        let schema = await this.dataService.generateJSONSchema(sortedDataArray)
        console.log(schema);
        await this.getSchema(schema)
        this.schema = schema
        // console.log(this.form.get('email_id'), 'iptcd');



      } else {
        console.warn('Response is not in the expected format.');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }
  pk = []
  async findpk() {
    this.pk = []
    let res = await this.dataService.PrimaryKey({
      pf_path: this.rrvconfig.pf_path,
      pf_name: this.rrvconfig.pf_name,
      app_cd: 'DD',

    })
    if (res['error'] == false) {
      this.pk = res['data'][0]['PK'] ? res['data'][0]?.['PK'] : []
      console.log(this.pk);
    }
    else {

    }
  }

  form = new FormGroup({});
  fields: FormlyFieldConfig[]
  originalModel: any
  async getSchema(schema: any) {
    this.fields = [this.formlyJsonschema.toFieldConfig(schema, {
      map: (field: FormlyFieldConfig, schema: JSONSchema7) => {
        this.model = this.rrvconfig.formData;
        this.originalModel = JSON.parse(JSON.stringify(this.model));

        if (this.rrvconfig.mode === 'view') {
          field.templateOptions.disabled = true;
        }

        if (schema.format === 'date-time') {
          field.templateOptions.type = 'datetime-local';
        } else if (schema.format === 'date') {
          field.templateOptions.type = 'date';
        } else if (schema.format === 'time') {
          field.templateOptions.type = 'time';
        } else if (schema.format === 'email') {
          field.templateOptions.type = 'email';
        }
        
        
        


        // if (schema.title && schema.title.startsWith('Dictionary Item')) {
        //   field.templateOptions.label = schema.title.replace('Dictionary Item', this.rrvconfig?.header['value']);
        // }
        //  else {
          field.templateOptions.label = schema.title;
        // }
        if (typeof field.key === 'string' && field.key.includes('json')) {
          if (!this.model[field.key]) {
            this.model[field.key] = JSON.stringify({});
          }
        }

        return field;
      }
    })];
    console.log(this.fields);

  }
  onSubmit(model: any) {
    console.log(model, this.fields);
    // Object.keys(model).forEach(key => {
    //   if (key.includes('json') && (model[key]==null  || model[key]==undefined)) {
    //     model[key] = {};  
    //   }
    // });
    let columns = Object.keys(model)
    let values = Object.values(model)
    this.dataService.addData({ columns: columns, values: values, pf_path: this.rrvconfig.pf_path, pf_name: this.rrvconfig.pf_name, app_cd: this.rrvconfig.app_cd }).then(response => {
      console.log('Data added successfully:', response);

      Swal.fire({
        title: 'Success!',
        text: 'Record added successfully!',
        icon: 'success',
        confirmButtonColor: '#4caf50',
        confirmButtonText: 'OK',
      });

      this.backtolist();

    }).catch(error => {
      console.error('Error adding data:', error);
    });
  }
  backtolist() {
    this.location.back();
  }
  async onUpdate() {
    //console.log(model);
    console.log('Form values:', this.model);

    let updateobj = {}
    console.log(Object.entries(this.model)[0])
    for (const key in this.model) {
      if (this.model.hasOwnProperty(key)) {
        if (this.model[key] !== this.originalModel[key]) {
          console.log(`${key} has been modified.`);
          updateobj[key] = this.model[key]

        }
      }
    }
    let where: any = {}

    where[Object.keys(this.model)[0]] = Object.values(this.model)[0]

    this.dataService.updateData({ pf_path: this.rrvconfig.pf_path, pf_name: this.rrvconfig.pf_name, app_cd: this.rrvconfig.app_cd, set: updateobj, where: where }).then(response => {
      //console.log('Data added successfully:', response);

      Swal.fire({
        title: 'Success!',
        text: 'Record Updated successfully!',
        icon: 'success',
        confirmButtonColor: '#4caf50',
        confirmButtonText: 'OK',
      });

      this.backtolist();

    }).catch(error => {
      console.error('Error updating data:', error);
    });

  }
  ngOnDestroy() {
    console.log('destroyed');

    this.subscriptions.unsubscribe();
  }





}
